class AssetLibraryCtrl {

    constructor($scope, $routeParams, CONTENT_TYPE, UserService, ApiService, CampaignService, EVENTS, Notification, $location, $rootScope) {
        this.$scope = $scope;
        this.UserService = UserService;
    }

}

angular.module("cpm").controller("AssetLibraryCtrl", ['$scope', '$routeParams', 'CONTENT_TYPE', 'UserService', 'ApiService', 'CampaignService', 'EVENTS', 'Notification', '$location', '$rootScope', AssetLibraryCtrl]);
